import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { environment } from '@env/environment';
import { FormGroup, FormBuilder, Validators, FormControl, PatternValidator } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [MessageService],
})
export class RegisterComponent implements OnInit {
  form: any = {};
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = '';
  version: string | null = environment.version;
  error: string | undefined;
  registerForm: any;
  isLoading = false;
  fieldPasswordType: boolean;
  fieldConfirmPasswordType: boolean;

  subscribeRes: any;
  constructor(
    private authService: AuthenticationService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.createForm();
  }

  ngOnInit(): void {}

  onSubmit(): void {
    this.isLoading = true;
    // console.log(JSON.stringify(this.registerForm.value));
    this.authService.register(this.registerForm.value).subscribe(
      (data) => {
        this.isSuccessful = true;
        this.isLoading = false;
        this.isSignUpFailed = false;
        this.messageService.add({
          key: 'register',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Registration-Success'),
        });
        setTimeout(() => {
          this.router.navigate(['../login'], { relativeTo: this.route });
        }, 2000);
      },
      (err) => {
        this.errorMessage = err.error.message;
        this.isSignUpFailed = true;
        this.messageService.add({
          key: 'register',
          severity: 'error',
          summary: 'Error',
          detail: err.error.message,
        });
      }
    );
    var mail = this.registerForm.value.mail;
    var subscription = this.registerForm.value.subscribe;
    if (mail && subscription) {
      this.subscribe(mail);
    }
  }

  private createForm() {
    // this.registerForm = this.formBuilder.group({
    //   mail: ['', Validators.required],
    //   name: ['', Validators.required],
    //   pass: ['', Validators.required, Validators.pattern],
    //   confirm_pass: ['', Validators.required],
    //   agreed: ['', Validators.required],
    //   subscribe: ['', Validators.required],
    // });
    this.registerForm = this.formBuilder.group({
      mail: new FormControl(null, [
        Validators.required,
        Validators.pattern(
          "^$|^([\\w-']+(?:\\.[\\w-']+)*)@((?:[\\w-]+\\.)*\\w[\\w-]+)\\.([a-zA-Z]+(?:\\.[a-zA-Z]+)?)$"
        ),
      ]),
      name: new FormControl(null, Validators.required),
      pass: new FormControl(null, Validators.required),
      confirm_pass: new FormControl(null, Validators.required),
      agreed: new FormControl('', Validators.required),
      subscribe: new FormControl(null),
    });
  }
  togglePasswordType() {
    this.fieldPasswordType = !this.fieldPasswordType;
  }
  toggleConfirmPasswordType() {
    this.fieldConfirmPasswordType = !this.fieldConfirmPasswordType;
  }
  subscribe(mail: any) {
    this.authService.Usersubscribe(mail).then((res) => {
      this.subscribeRes = res;
    });
  }
  policy() {
    if (this.registerForm.value.agreed == 'true') {
      this.registerForm.value.agreed = true;
    } else {
      this.registerForm.value.agreed = false;
    }
  }
}
